import React from "react";
import "../../../../css/Marketing/FinancialPromotions/Buttons/StatusTag.css";

const StatusTag = ({ status }) => {
  // Normalize status for className and display
  const normalized = (status || "").toLowerCase().replace(/\s+/g, "-");
  return (
    <span
      className={`status-tag status-tag--${normalized} FP_Content_Semibold`}
    >
      {status}
    </span>
  );
};

export default StatusTag;
